import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { DataGrid } from '@material-ui/data-grid';
import {
  BACKGROUND_DARK,
  CELL_LIGHT_COLOR,
  LIGHT_GREY_COLOR,
  PRIMARY_COLOR,
  EXPAND_ROW_COLOR_DARK,
  SELECTED_TRANSACTION_BOX_SHADOW, LIGHT_UPDATED_FIELD, BLACK_COLOR, CUSTOM_BORDER,
} from '../../../const/color-const';
import { darken } from '@material-ui/core/styles';
import RenderBreakpoint from '../breakpoints/RenderBreakpoint';
import MobilePaginationTable from './MobilePaginationTable';
import { FormattedMessage, useIntl } from 'react-intl';
import { DefaultToolbar } from '../../pages/reports/standard/StandardReportCustom';
import { getDataGridTranslations } from '../../pages/reports/ReportsUtils';
import { SearchableDataGrid } from '../../pages/transactions/TransactionSearchDataGrid';
import { handleClassnames } from '../../pages/reports/standard/StandardReportUtils';

const styles = (theme => ({
  dataGridTable: {
    boxShadow: theme.palette.type === 'light' ? `0 0 20px 0 ${LIGHT_GREY_COLOR}` : `0 0 20px 0 #0d0f15`,
    marginBottom: 50,
    borderRadius: 12,
    border: 'none',
    '& .MuiDataGrid-toolbarContainer, .MuiDataGrid-toolbar': {
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      background: PRIMARY_COLOR,
      padding: 0,
      '& button': {
        height: 34,
        border: `1px solid ${CUSTOM_BORDER}`,
        margin: theme.spacing(1, 0.5, 1, 0.5),
        background: '#ffd043',
        '&:hover': {
          border: `1px solid ${BLACK_COLOR}`,
        },
        '& span[class*="MuiButton-startIcon"]': {
          marginLeft: 4,
        },
        '& span[class*="MuiButton-endIcon"]': {
          marginRight: 2,
          '& svg:last-of-type': {
            height: '100%',
            width: 24,
          },
        },
      },
      '& span': {
        color: 'black',
        textTransform: 'capitalize;',
      },
    },
    '& .MuiDataGrid-columnsContainer': {
      background: PRIMARY_COLOR,
      color: 'black',
      '& svg': {
        color: 'rgba(0, 0, 0, 0.3)',
      },
      '& .MuiDataGrid-cell:empty': {
        display: 'none',
      },
    },
    '& .MuiDataGrid-window': {
      '& .MuiDataGrid-renderingZone, .rendering-zone': {
        display: 'flex',
        flexDirection: 'column',
        '& .totalCategory': {
          fontWeight: 'bold',
        },
        '& .selectedId': {
          fontWeight: 'bold',
          background: theme.palette.type === 'light' ? `${LIGHT_UPDATED_FIELD} !important` : `${EXPAND_ROW_COLOR_DARK} !important`,
          boxShadow: SELECTED_TRANSACTION_BOX_SHADOW,
        },
        '& .Mui-even, .MuiDataGrid-row': {
          border: theme.palette.type === 'light' ? '1px solid rgba(0, 0, 0, 0.05)' : '1px solid rgba(255, 255,255, .1)',
          background: 'white',
          '&:nth-child(even)': {
            backgroundColor: theme.palette.type === 'light' ? 'white' : (BACKGROUND_DARK),
          },
          '&:nth-child(odd)': {
            backgroundColor: theme.palette.type === 'light' ? CELL_LIGHT_COLOR : darken(BACKGROUND_DARK, 0.2),
          },
          '& .MuiDataGrid-cell': {
            padding: theme.spacing(0, 0.5, 0, 0.5),
            '& span': {
              letterSpacing: '0.1px',
              textAlign: 'center',
            },
          },
          '& .MuiDataGrid-cell:empty': {
            display: 'none',
          },
        },
      },
    },
    '& .totalCategory': {
      order: 999,
    },
  },
}));

const RegularDataGrid = ({
                           rows,
                           columns,
                           reportName,
                           classes,
                           setDownloadProgress,
                           id,
                           page,
                           componentProps,
                           onPageChange,
                           components,
                           handleExtraFunction,
                           isAccordion,
                           includeSearch,
                           ...rest
                         }) => {
  
  const { formatMessage } = useIntl();
  const { search, handleSearchChange, filteredRows, pageIdx } = SearchableDataGrid(rows, columns, page, 100);
  
  return <>
    <RenderBreakpoint desktop>
      <DataGrid
        className={classes.dataGridTable}
        getRowClassName={(params) => handleClassnames({ params, reportName, id })}
        showToolbar
        disableColumnMenu
        autoHeight
        hideFooterSelectedRowCount
        density="compact"
        columns={columns}
        page={pageIdx}
        rows={filteredRows}
        onPageChange={onPageChange}
        components={components}
        localeText={getDataGridTranslations(formatMessage)}
        componentsProps={{
          pagination: {
            labelRowsPerPage: <FormattedMessage id="report.footer.rowsPerPage" defaultMessage="Rows per page" />,
          },
          toolbar: {
            includeSearch: includeSearch,
            search: search,
            handleSearchChange: handleSearchChange,
          },
        }}
        rest={rest}
      />
    </RenderBreakpoint>
    
    <RenderBreakpoint mobile>
      <MobilePaginationTable
        rows={rows}
        columns={columns}
        reportName={reportName}
        setDownloadProgress={setDownloadProgress}
        components={components}
        handleExtraFunction={handleExtraFunction}
        isAccordion={isAccordion}
      />
    </RenderBreakpoint>
  </>;
};

RegularDataGrid.defaultProps = {
  components: {
    Toolbar: DefaultToolbar,
  },
  includeSearch: false,
};

export default withStyles(styles)(RegularDataGrid);